import { render, staticRenderFns } from "./quesSuccess1.vue?vue&type=template&id=16fae2bf"
import script from "./quesSuccess1.vue?vue&type=script&lang=js"
export * from "./quesSuccess1.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess1.vue?vue&type=style&index=0&id=16fae2bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports